import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { queryClient } from "../lib/queryClient";
import { meQuery, type Me } from "../hooks/useAuth";
import { hasPermission } from "../hooks/useCan";
import { TrainersScreen, type TrainersSearch } from "../components/trainers/TrainersScreen";

const searchSchema = z.object({
  tab: z.enum(["calendar", "packages", "classes"]).optional(),
  date: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),
  trainer: z.number().int().nonnegative().optional(),
});

export const Route = createFileRoute("/_auth/trainers")({
  staticData: { titleKey: "nav.trainers", breadcrumbKey: "breadcrumb.operate", breadcrumbN: 2 },
  validateSearch: searchSchema,
  beforeLoad: () => {
    const me = queryClient.getQueryData<Me>(meQuery.queryKey);
    if (me && !hasPermission(me, "view_training")) throw redirect({ to: "/clients" });
  },
  component: TrainersRoute,
});

function TrainersRoute() {
  const search = Route.useSearch() as TrainersSearch;
  const navigate = useNavigate({ from: "/trainers" });
  return (
    <TrainersScreen
      search={search}
      onNavigate={(next) => {
        navigate({ search: (prev) => ({ ...prev, ...next }) as never });
      }}
    />
  );
}
